import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

export const FaqJson = ({ faqs }) => {
  const json = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map(faq => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: faq.answer
      }
    }))
  };
  return (
    <Helmet>
      {faqs && faqs.length && (
        <script type="application/ld+json">{JSON.stringify(json)}</script>
      )}
    </Helmet>
  );
};

FaqJson.propTypes = {
  faqs: PropTypes.array.isRequired
};

const toggleAccordion = e => {
  const panel = e.target;
  const panelAccordionContent = panel.querySelector(`.accordion-content`);
  const panelIcon = panel.querySelector(".icon");

  if (panelAccordionContent.className.includes("collapse")) {
    panelAccordionContent.classList.remove("collapse");
    panelIcon.classList.add("icon-rotate");
  } else {
    panelAccordionContent.classList.add("collapse");
    panelIcon.classList.remove("icon-rotate");
  }
};

const Faq = ({ question, answer }) => {
  if (!question || !answer) return null;

  return (
    <>
      <div onClick={toggleAccordion} style={{ cursor: 'pointer'}} className="card card-sm card-body card--no-hover">
        <div style={{pointerEvents: 'none'}} className="accordion-panel-title" aria-controls="panel-2">
          <p aria-controls="panel-2">
            <strong aria-controls="panel-2">{question}</strong>
          </p>
          <img
            className="icon"
            src="https://www.datocms-assets.com/16499/1583766454-plus.svg"
            aria-controls="panel-2"
          />
        </div>
        <div style={{pointerEvents: 'none'}} className="accordion-content collapse">
          <div className="pt-3">
            <p>{answer}</p>
          </div>
        </div>
      </div>
    </>
  );
};

Faq.propTypes = {
  question: PropTypes.string.isRequired,
  answer: PropTypes.string.isRequired
};

export default Faq;
